import { forwardRef } from 'react';
import styled, { keyframes } from 'styled-components/macro';
import { space, SpaceProps } from 'styled-system';

const rotate = keyframes`
  from {transform: rotate(0deg);}
  to {transform: rotate(360deg);}
`;

type LoaderProps = { width?: string; height?: string; p?: number };

const Spinner = styled.div<LoaderProps>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border: 3px solid ${(props) => props.theme.colors.primary.regular};
  border-top: 3px solid
    ${(props) => (props.color ? props.color : 'transparent')};
  border-radius: 50%;
  transition-property: transform;
  animation-name: ${rotate};
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`;

const StyledSpinner = styled.div<SpaceProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  ${space}
`;

const Loader = forwardRef<HTMLDivElement, LoaderProps>(
  ({ width = '30px', height = '30px', p = '' }, ref) => {
    return (
      <StyledSpinner p={p} className="styled-spinner" ref={ref}>
        <Spinner width={width} height={height} />
      </StyledSpinner>
    );
  }
);

export default Loader;
